<template>
  <v-dialog v-model="isDialogVisible" max-width="850">
    <v-card class="prompts-dialog">
      <v-btn class="button-close ma-4" icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <h4 class="mt-1">Редактирование системного промпта</h4>
      </v-card-title>
      <v-card-text>
        <div class="d-flex mt-5">
          <v-textarea v-model="content" counter rows="10" outlined dense class="_mr-3">
          </v-textarea>
        </div>
        <div class="d-flex justify-end mt-2 mb-3" >
          <v-btn @click="close()" color="primary" outlined class="mr-3">Отменить</v-btn>
          <v-btn @click="save()" color="primary" :disabled="!content" :loading="loading.saveSystemPrompt">Сохранить</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <MsgDialog v-model="showOkEditDialog" @ok="onOk()"
      title="Промпт успешно отредактирован"
    />
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from 'vuex';
import MsgDialog from "@/components/ui/MsgDialog"

export default {
  name: 'PromptEditDialog',
  components: {
    MsgDialog
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: Boolean,
  },
  data: () => ({
    content: '',
    showOkEditDialog: false,
  }),
  watch: {
    async value(val) {
      if (val) {
          const prompt = await this.loadSystemPrompt()
          this.content = prompt ? prompt : ''
      }
    },
  },
  computed: {
    ...mapGetters({
      loading: 'ai/prompts/loading',
    }),
    isDialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.close()
        }
      },
    },
  },
  methods: {
    ...mapActions({
      loadSystemPrompt: 'ai/prompts/loadSystemPrompt',
      saveSystemPrompt: 'ai/prompts/saveSystemPrompt',
    }),
    close(ret) {
      this.$emit('input', ret);
    },
    async save(ret) {
      const response = await this.saveSystemPrompt(this.content)
      if (response) {
        this.showOkEditDialog = true
      }
    },
    onOk() {
      this.showOkEditDialog = false
      this.close()
    }
  }
}
</script>

<style>

</style>
